import * as React from 'react';

export const Disabled = (props) => <div className="co-disabled">{props.children}</div>;
